import { render, staticRenderFns } from "./BigCTA.vue?vue&type=template&id=964624ac&scoped=true&"
import script from "./BigCTA.vue?vue&type=script&lang=ts&"
export * from "./BigCTA.vue?vue&type=script&lang=ts&"
import style0 from "./BigCTA.vue?vue&type=style&index=0&id=964624ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964624ac",
  null
  
)

export default component.exports